import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=e8bf980a"
import script from "./detail.js?vue&type=script&lang=js&external"
export * from "./detail.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports